import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { UpdateDonorDataRequestBody } from '@/api/apis/case/opo-case';
import { queryClient } from '@/queries';
import { invalidateCaseItemQueries, opoCaseQueryKeys, updateCaseField } from '@/queries/case';

export const useUpdateOpoCaseDonorDataMutation = () =>
  useMutation({
    mutationFn: ({ caseId, ...body }: UpdateDonorDataRequestBody & { caseId: string }) =>
      api.case.opo.updateOpoCaseDonorData(caseId, body),
    onSuccess: (opoCase, variables) => {
      updateCaseField(variables.caseId, 'donorData', opoCase.donorData);
      updateCaseField(variables.caseId, 'matchId', opoCase.matchId);
      queryClient.invalidateQueries({ queryKey: opoCaseQueryKeys.getItem(variables.caseId) });
      invalidateCaseItemQueries(variables.caseId);
    },
  });
